import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./service.css";
import CreateServiceModal from "./CreateServiceModal";
import EditServiceModal from "./EditServiceModal";
import { IoIosAddCircleOutline } from "react-icons/io";
import { REST_API_URL } from './../api/config';

const BASE_URL = REST_API_URL;

const getUserTimeZone = () => {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
};

const buildHeaders = (token, additionalHeaders = {}) => {
  const headers = {
    "Content-Type": "application/json",
    ...additionalHeaders,
  };
  
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }
  
  const timezone = getUserTimeZone();
  if (timezone) {
    headers["User-Timezone"] = timezone;
  }
  
  return headers;
};

export default function Service() {
  const [services, setServices] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const isFetched = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (isFetched.current) return;
    isFetched.current = true;

    const loadData = async () => {
      try {
        setLoading(true);
        const token =
          localStorage.getItem("accessToken") ||
          localStorage.getItem("token");

        if (!token) throw new Error("No access token found — please log in.");

        const headers = buildHeaders(token);

        const res = await fetch(`${BASE_URL}/service/my-services/`, {
          headers,
        });

        if (res.status === 401) {
          localStorage.removeItem("accessToken");
          setError("Session expired. Please log in again.");
          setTimeout(() => navigate("/login"), 2000);
          return;
        }

        if (!res.ok) throw new Error(`Failed to load services (${res.status})`);

        const data = await res.json();
        setServices(data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [navigate]);

  return (
    <div className="create-service-page">
      <div className="create-service-page-card">
        <div className="create-service-page-header">
          <button
            className="create-service-page-back-btn"
            onClick={() => navigate(-1)}
          >
            ← Back
          </button>
          <div className="create-service-page-title">
            <h2>My Services</h2>
            <p>Set up your services</p>
          </div>
        </div>

        <div className="create-service-page-container">
          {!loading &&
            !error &&
            services.map((s) => (
              <div className="create-service-page-item" key={s.id}>
                <div className="create-service-page-image">
                  <img
                    src={s.image || "/service-placeholder.jpg"}
                    alt={s.name}
                  />
                </div>
                <div className="create-service-page-info">
                  <h3>{s.name}</h3>
                  <p>{s.description || "No description available."}</p>
                  <div className="create-service-page-divider"></div>
                  <div className="create-service-page-price-info">
                    <div className="create-service-page-price">
                      <span>💲 Price:</span> {s.price || "—"}$
                    </div>
                    <div className="create-service-page-duration">
                      ⏱ Duration: {s.duration || "—"} min
                    </div>
                  </div>
                </div>
              </div>
            ))}

          <button
            className="create-service-page-create-card"
            onClick={() => setShowModal(true)}
          >
            Create Service <IoIosAddCircleOutline />
          </button>

          {showModal && <EditServiceModal onClose={() => setShowModal(false)} />}
        </div>

        <div className="create-service-page-footer">
          <button
            className="create-service-page-next-btn"
            onClick={() => navigate("/next-step")}
          >
            Next
          </button>
          <p className="create-service-page-step">Step 3/5</p>
        </div>
      </div>
    </div>
  );
}